(function () {
  function wireLoopCarousel(section) {
    if (!section) return false;

    var slideshowId = section.getAttribute("data-hw-loop-slideshow-id");
    var slideshow = section.querySelector('[data-slideshow-id="' + slideshowId + '"]');
    if (!slideshow || typeof slideshow.next !== "function") return false;

    var nav = section.querySelector(".hw-carousel-navigation");
    if (nav) {
      var arrows = nav.querySelectorAll('button[ref="previous"], button[ref="next"]');
      if (arrows.length === 0) {
        arrows = nav.querySelectorAll(
          '.hw-carousel-navigation__control[ref="previous"], .hw-carousel-navigation__control[ref="next"], .slideshow-control[ref="previous"], .slideshow-control[ref="next"]'
        );
      }

      arrows.forEach(function (btn) {
        var ref = btn.getAttribute("ref");
        if (ref === "previous" || ref === "next") {
          btn.removeAttribute("on:click");
          btn.addEventListener(
            "click",
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (ref === "next") slideshow.next(e);
              else slideshow.previous(e);
            },
            true
          );
        }
      });
    }

    section.setAttribute("data-hw-loop-wired", "true");
    return true;
  }

  var tryCount = 0;
  var maxTries = 100;

  function tryWire() {
    var sections = Array.prototype.slice.call(
      document.querySelectorAll("[data-hw-loop-slideshow-id]:not([data-hw-loop-wired='true'])")
    );
    if (!sections.length) return;

    var pending = 0;
    sections.forEach(function (section) {
      if (!wireLoopCarousel(section)) pending++;
    });

    if (pending === 0) return;
    tryCount++;
    if (tryCount > maxTries) return;

    if (typeof customElements !== "undefined" && customElements.whenDefined) {
      customElements.whenDefined("slideshow-component").then(function () {
        setTimeout(tryWire, 0);
      });
    } else {
      setTimeout(tryWire, 50);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(tryWire, 0);
    });
  } else {
    setTimeout(tryWire, 0);
  }
})();
